export default __webpack_public_path__ + "images/lev_6e787e.svg";